function formatTime(date) {
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export default function ChatBubble({ message, onCtaClick }) {
  const { role, content, cta, timestamp } = message;
  const isUser = role === 'user';

  return (
    <div className={`chat-bubble-row ${role}`}>
      <div className={`chat-bubble ${role}`}>{content}</div>
      {!isUser && cta && (
        <button
          type="button"
          className="chat-cta-btn"
          onClick={() => onCtaClick?.(cta)}
        >
          {cta.label}
        </button>
      )}
      <span className="chat-bubble-time">
        {formatTime(timestamp || new Date())}
        {isUser && ' ✓✓'}
      </span>
    </div>
  );
}
